export const BUDGET_CATEGORY_TAXONOMY = [
  {
    id: 'housing',
    name: 'Housing',
    subcategories: [
      { id: 'rent-mortgage', name: 'Rent / Mortgage' },
      { id: 'property-tax', name: 'Property Tax' },
      { id: 'home-maintenance', name: 'Home Maintenance' },
      { id: 'home-repairs', name: 'Home Repairs' },
      { id: 'utilities-electricity', name: 'Utilities: Electricity' },
      { id: 'utilities-water', name: 'Utilities: Water' },
      { id: 'utilities-gas', name: 'Utilities: Gas' },
      { id: 'waste-recycling', name: 'Waste & Recycling' },
      { id: 'security-estate-guards', name: 'Security (estate, guards)' }
    ]
  },
  {
    id: 'transportation',
    name: 'Transportation',
    subcategories: [
      { id: 'fuel', name: 'Fuel' },
      { id: 'public-transport', name: 'Public Transport' },
      { id: 'car-maintenance', name: 'Car Maintenance' },
      { id: 'car-repairs', name: 'Car Repairs' },
      { id: 'car-insurance', name: 'Car Insurance' },
      { id: 'registration-licensing', name: 'Registration / Licensing' },
      { id: 'parking', name: 'Parking' },
      { id: 'ride-hailing', name: 'Ride-Hailing (Uber, Bolt)' },
      { id: 'vehicle-loan-payment', name: 'Vehicle Loan Payment' }
    ]
  },
  {
    id: 'food-groceries',
    name: 'Groceries & Food',  // SSOT: Unified with categoryTaxonomy.js canonical name
    subcategories: [
      { id: 'groceries', name: 'Groceries & Food' },
      { id: 'fresh-produce', name: 'Fresh Produce' },
      { id: 'meat-seafood', name: 'Meat & Seafood' },
      { id: 'snacks-drinks', name: 'Snacks & Drinks' },
      { id: 'restaurants-dining-out', name: 'Restaurants / Dining Out' },
      { id: 'cafes-coffee', name: 'Cafes / Coffee' },
      { id: 'meal-delivery', name: 'Meal Delivery (Jumia Food, Uber Eats)' }
    ]
  },
  {
    id: 'health-wellness',
    name: 'Health & Wellness',
    subcategories: [
      { id: 'health-insurance', name: 'Health Insurance' },
      { id: 'medications', name: 'Medications' },
      { id: 'clinic-hospital', name: 'Clinic Visits / Hospital' },
      { id: 'lab-tests', name: 'Lab Tests' },
      { id: 'dental', name: 'Dental' },
      { id: 'optical', name: 'Optical' },
      { id: 'mental-health', name: 'Mental Health' },
      { id: 'gym-membership', name: 'Gym Membership' },
      { id: 'fitness-classes-apps', name: 'Fitness Classes / Wellness Apps' }
    ]
  },
  {
    id: 'personal-family-care',
    name: 'Personal & Family Care',
    subcategories: [
      { id: 'childcare', name: 'Childcare' },
      { id: 'school-fees', name: 'School Fees' },
      { id: 'school-supplies', name: 'School Supplies' },
      { id: 'personal-care', name: 'Personal Care (hair, grooming)' },
      { id: 'skincare-cosmetics', name: 'Skincare / Cosmetics' },
      { id: 'household-help', name: 'Household Help (maid, nanny)' },
      { id: 'parenting-essentials', name: 'Parenting Essentials (diapers, formula)' }
    ]
  },
  {
    id: 'finance-savings',
    name: 'Finance & Savings',
    subcategories: [
      { id: 'savings-deposit', name: 'Savings Deposit' },
      { id: 'investments', name: 'Investments' },
      { id: 'loan-repayment', name: 'Loan Repayment' },
      { id: 'emergency-fund', name: 'Emergency Fund' },
      { id: 'retirement-fund', name: 'Retirement Fund' },
      { id: 'transfers-to-others', name: 'Transfers to Others' },
      { id: 'bank-charges', name: 'Bank Charges' }
    ]
  },
  {
    id: 'entertainment-leisure',
    name: 'Entertainment & Leisure',
    subcategories: [
      { id: 'movies-cinema', name: 'Movies / Cinema' },
      { id: 'events-concerts', name: 'Events / Concerts' },
      { id: 'hobbies-crafts', name: 'Hobbies & Crafts' },
      { id: 'games', name: 'Games' },
      { id: 'subscriptions', name: 'Subscriptions (Netflix, Spotify, Apple Music)' },
      { id: 'books-magazines', name: 'Books & Magazines' }
    ]
  },
  {
    id: 'shopping-lifestyle',
    name: 'Shopping & Lifestyle',
    subcategories: [
      { id: 'clothing', name: 'Clothing' },
      { id: 'shoes', name: 'Shoes' },
      { id: 'accessories', name: 'Accessories' },
      { id: 'electronics', name: 'Electronics' },
      { id: 'home-appliances', name: 'Home Appliances' },
      { id: 'furniture', name: 'Furniture' },
      { id: 'gifts', name: 'Gifts' }
    ]
  },
  {
    id: 'communications-tech',
    name: 'Communications & Tech',
    subcategories: [
      { id: 'mobile-data', name: 'Mobile Data' },
      { id: 'airtime', name: 'Airtime' },
      { id: 'internet-subscription', name: 'Internet Subscription' },
      { id: 'software-apps', name: 'Software / Apps' },
      { id: 'device-repairs', name: 'Device Repairs' },
      { id: 'cloud-storage', name: 'Cloud Storage' }
    ]
  },
  {
    id: 'business-work',
    name: 'Business & Work',
    subcategories: [
      { id: 'work-tools-equipment', name: 'Work Tools & Equipment' },
      { id: 'courses-certifications', name: 'Courses / Certifications' },
      { id: 'professional-memberships', name: 'Professional Memberships' },
      { id: 'workspace-coworking', name: 'Workspace / Coworking' },
      { id: 'marketing-ads', name: 'Marketing / Ads' },
      { id: 'freelancers-contractors', name: 'Freelancers / Contractor Payments' }
    ]
  },
  {
    id: 'travel',
    name: 'Travel',
    subcategories: [
      { id: 'flights', name: 'Flights' },
      { id: 'hotels', name: 'Hotels' },
      { id: 'transport-taxis', name: 'Transport & Taxis' },
      { id: 'visa-fees', name: 'Visa Fees' },
      { id: 'travel-insurance', name: 'Travel Insurance' },
      { id: 'vacation-spending', name: 'Vacation Spending' },
      { id: 'tours-activities', name: 'Tours & Activities' }
    ]
  },
  {
    id: 'emergencies-misc',
    name: 'Emergencies / Miscellaneous',
    subcategories: [
      { id: 'unexpected-bills', name: 'Unexpected Bills' },
      { id: 'one-off-purchases', name: 'One-off Purchases' },
      { id: 'fines-penalties', name: 'Fines / Penalties' },
      { id: 'unknown-category', name: 'Unknown Category' }
    ]
  }
];

export const findBudgetCategory = (categoryId) =>
  BUDGET_CATEGORY_TAXONOMY.find((category) => category.id === categoryId) || null;

export const findBudgetSubcategory = (categoryId, subcategoryId) => {
  const category = findBudgetCategory(categoryId);
  if (!category) return null;
  return category.subcategories.find((sub) => sub.id === subcategoryId) || null;
};
